<template>
    <div v-if="pmp_case_details">
        <modal :show.sync="show_modal" :hide-footer="true">
            <h3>Select available unit to change:</h3>
            <el-select
            filterable
                class="w-100 my-3"
                v-model="change_unitno_id"
            >
                <el-option
                    class="select-primary"
                    v-for="item in pmp_case_details.change_unit_list"
                    :key="item.unitno_id"
                    :label="item.unit_no"
                    :value="item.unitno_id"
                >
                </el-option>
            </el-select>
            <div class="d-flex justify-content-center">
                <el-button class="bg-orange text-white" @click="confirmChange" :loading="is_loading">Confirm</el-button>
            </div>
        </modal>  
    </div>
</template>
<script>
import { Select, Option, Button } from 'element-ui'
    import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'
import { useAuthStore } from '@/stores/authStore'
import { mapState, mapActions } from 'pinia'

    export default {
        props:['product', 'pmp_case_details'],
        mixins: [notifyFunctionMixin],
        components: {
            [Option.name]: Option,
            [Select.name]: Select,
            [Button.name]: Button,
        },
        data() {
            return {
                is_loading:false,
                show_modal: false,
                change_unitno_id: null
            }
        },
        watch:{
            product(newVal){
                this.change_unitno_id = null
            }
        },
        computed:{
            ...mapState(useAuthStore, ['auth_user'])
        },
        methods: {
            toggleView() {
                this.show_modal = !this.show_modal;
            },
            confirmChange(){
                if(!this.change_unitno_id){
                    this.errorFunction(null, 'Please select a unit')
                    return
                }
                this.is_loading = true
                let data = {
                    unitno_id: this.change_unitno_id,
                    created_by: this.auth_user.id
                }
                axios.post(services.lookup + 'pmp/cases.im2uv2/'+this.product.prod_id+'/change-unit', data, {headers: getHeader()})
                    .then(res => {
                        this.show_modal = false
                        this.is_loading = false
                        caseEventBus.$emit('refresh-cases')
                        this.notifySuccess('<b>Case</b> - Changed Unit Successful.')
                    })
                    .catch(e =>{
                        this.is_loading = false
                        this.errorFunction(e)
                    })
            }
        },
    }
</script>